import script from "./ProjectTree.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectTree.vue?vue&type=script&setup=true&lang=js"

import "./ProjectTree.vue?vue&type=style&index=0&id=482e68ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-482e68ae"]])

export default __exports__